import React, { useState } from 'react'
import { Pencil, Trash, CurrencyCircleDollar, Notepad, Eye, EyeSlash } from '@phosphor-icons/react'
import { Step6DropInTicket, TicketStatus } from 'types/Classes/Classes'
import { capitalizeFirstLetter } from 'helper/utility'
import { classesEventStore } from 'state/classes/classesStore'
import ButtonSpinner from 'components/global/ButtonSpinner'
import DropInTicketsModal from '../Modals/DropinTicket/DropInTickets'
import { useDeleteClassesStep6DropInTicket, useChangeDropInTicketStatus } from 'api/Classes/Step6Tickets/Tickets'
import { Popconfirm, Dropdown } from 'antd'

interface DropInTicketCompProps {
  details: Step6DropInTicket & { _id?: string; status?: string }
}

const DropInTicketComp: React.FC<DropInTicketCompProps> = ({ details }) => {
  const classesData = classesEventStore(store => store.classesData) as any
  const setClassesData = classesEventStore(store => store.setClassesData)

  const [openDropInModal, setOpenDropInModal] = useState<boolean>(false)
  const { mutate: deleteDropInTicket, isLoading: deleteLoading } =
    useDeleteClassesStep6DropInTicket()
  const { mutate: changeTicketStatus, isLoading: changeTicketStatusLoading } =
    useChangeDropInTicketStatus()

  const visible = details.status === 'active'

  const handleMenuClick = (operation: 'edit' | 'visibility') => {
    if (operation === 'edit') {
      setOpenDropInModal(true)
      return
    }

    const payload = {
      status: visible ? TicketStatus.Disabled : TicketStatus.Active,
      dropInTicketId: details._id,
    }

    changeTicketStatus(
      { classId: classesData?._id, payload },
      {
        onSuccess: newData => {
          setClassesData({ ...classesData, ...newData })
        },
      },
    )
  }

  const manageOptions = [
    {
      key: 'edit',
      label: (
        <div
          className="flex gap-16px align-center"
          onClick={() => handleMenuClick('edit')}
        >
          <Pencil size={20} color="#000" />
          <p className="text-14 w-500">Edit ticket</p>
        </div>
      ),
    },
    {
      key: 'visibility',
      label: (
        <div
          className="flex gap-16px align-center"
          onClick={() => handleMenuClick('visibility')}
        >
          {visible ? <EyeSlash size={20} color="#000" /> : <Eye size={20} color="#000" />}
          <p className="text-14 w-500">Make {visible ? 'Disable' : 'Enable'}</p>
        </div>
      ),
    },
    {
      key: 'delete',
      label: (
        <Popconfirm
          title="Delete Drop-in Ticket"
          onConfirm={() => {
            deleteDropInTicket(
              { classId: classesData?._id },
              {
                onSuccess: newData => {
                  setClassesData({ ...classesData, dropInTicket: null, ...newData })
                },
              },
            )
          }}
          okText="Yes"
          cancelText="No"
        >
          <div className="flex gap-16px align-center">
            <Trash size={20} color="#000" />
            <p className="text-14 w-500">Delete ticket</p>
          </div>
        </Popconfirm>
      ),
    },
  ]

  const handleDelete = () => {
    deleteDropInTicket(
      { classId: classesData?._id },
      {
        onSuccess: newData => {
          setClassesData({ ...classesData, dropInTicket: null, ...newData })
        },
      },
    )
  }

  return (
    <>
      <div
        className={`ticket-main-cont`}
        style={{ backgroundColor: `#${details.color}` }}
      >
        <div className="content">
          <div className="flex justify-between align-center">
            <h2 className="text-18 w-600">
              {capitalizeFirstLetter(details.name)}
            </h2>
            {changeTicketStatusLoading ? (
              <ButtonSpinner size={20} color={'#000'} />
            ) : visible ? (
              <Eye size={20} color="#000" />
            ) : (
              <EyeSlash size={20} color="#000" />
            )}
          </div>

          <p className="text-14 w-600 mt-15px">{`$${
            details.price
          }/${details.priceUnit}`}</p>

          <Dropdown
            menu={{ items: manageOptions }}
            placement="bottomLeft"
            arrow={false}
            className={`ml-20px mr-10px ${
              changeTicketStatusLoading && 'no-pointer-events'
            }`}
            overlayStyle={{ width: '300px' }}
            trigger={['click']}
          >
            <button className={`ticket-button pointer`}>Manage</button>
          </Dropdown>
        </div>
        <div className="dull-color"></div>
      </div>

      {openDropInModal && (
        <DropInTicketsModal
          modalOpen={openDropInModal}
          modalClose={setOpenDropInModal}
          data={details}
        />
      )}
    </>
  )
}

export default DropInTicketComp
